import { Component, effect, inject, Input, input, signal } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BlogService } from '../../services/blog.service';
import { DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-news-sidebar',
  imports: [DatePipe, RouterLink, FormsModule],
  templateUrl: './news-sidebar.html',
  styleUrl: './news-sidebar.scss',
})
export class NewsSidebar {
  recentPosts = signal<any>([]);
  isLoading = signal(true);
  router = inject(Router);

  blogService = inject(BlogService);
  
  tags = signal<any>([]);
  showMoreTags = signal(false);

  @Input() query: string = '';
  showRecentPosts = input<boolean>(true);

  constructor() {
    effect(() => {
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.loadRecentPosts();
        }
      });
    });
  }

  ngOnInit(): void {
    this.loadRecentPosts();
    this.loadTags();
  }

  async loadRecentPosts() {
    if (!this.showRecentPosts()) return;
    this.isLoading.set(true);
    try {
      const result = await this.blogService.getRecentPostsFromApi();
      this.recentPosts.set(result.posts);
    } catch (error) {
      console.error('Error loading recent posts', error);
    } finally {
      this.isLoading.set(false);
    }
  }

  async loadTags() {
    this.isLoading.set(true);
    try {
      const result = await this.blogService.getNewsTagsFromApi();
      this.tags.set(result);
    } catch (error) {
      console.error('Error loading tags', error);
    } finally {
      this.isLoading.set(false);
    }
  }

  onSearch(event: Event) {
    event.preventDefault();
    this.router.navigate(['/news/search', this.query]);
  }
}
